
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.828 20.863a11.687 11.687 0 00-2.519-3.735 11.738 11.738 0 00-3.734-2.519c-.012-.006-.025-.009-.037-.015A7.749 7.749 0 0012 .563a7.749 7.749 0 00-7.75 7.75 7.744 7.744 0 003.213 6.284l-.038.016c-1.4.59-2.656 1.437-3.734 2.518a11.738 11.738 0 00-2.52 3.735A11.617 11.617 0 00.25 25.18a.25.25 0 00.25.256h1.875a.25.25 0 00.25-.243 9.317 9.317 0 012.744-6.385A9.313 9.313 0 0112 16.062c2.506 0 4.86.976 6.631 2.747a9.317 9.317 0 012.744 6.385.247.247 0 00.25.244H23.5a.25.25 0 00.25-.257 11.647 11.647 0 00-.922-4.319zM12 13.688a5.34 5.34 0 01-3.8-1.575 5.34 5.34 0 01-1.575-3.8 5.34 5.34 0 011.575-3.8A5.34 5.34 0 0112 2.938a5.34 5.34 0 013.8 1.575 5.34 5.34 0 011.575 3.8 5.34 5.34 0 01-1.575 3.8 5.34 5.34 0 01-3.8 1.575z","fill":"#FFF"}})])
          )
        }
      }
    